<template>
    <img v-if="logo.name === 'LogoBrr'" src="@/components/logos/logo-home.png" width="130"/>
    <component :is="logo.name" class="img-fluid" :width="logo.width" :height="logo.height" v-else/>
</template>
<script>
import LogoCashforce from '@/components/logos/LogoCashforce';
import LogoTecban from '@/components/logos/LogoTecban';
import LogoFMS from '@/components/logos/LogoFMS';
import LogoCiabra from '@/components/logos/LogoCiabra';
import LogoNetmoney from '@/components/logos/LogoNetmoney';
import LogoViaInvest from '@/components/logos/LogoViaInvest';
import LogoM7 from '@/components/logos/LogoM7';
import LogoIntrabank from '@/components/logos/LogoIntrabank';
import LogoIriom from '@/components/logos/LogoIriom.vue';
import LogoBiz2bank from '@/components/logos/LogoBiz2bank.vue';
import LogoSomosPremium from '@/components/logos/LogoSomosPremium.vue';
import LogoCarbon from '@/components/logos/LogoCarbon.vue';
import LogoAmb from '@/components/logos/LogoAmb.vue';
import LogoMGpay from '@/components/logos/LogoMGpay.vue';
import LogoUniverso from '@/components/logos/LogoUniverso.vue';
import LogoSomma from '@/components/logos/LogoSomma.vue';

export default {
    components: {
        LogoCashforce,
        LogoTecban,
        LogoFMS,
        LogoCiabra,
        LogoNetmoney,
        LogoViaInvest,
        LogoM7,
        LogoIntrabank,
        LogoIriom,
        LogoBiz2bank,
        LogoSomosPremium,
        LogoCarbon,
        LogoAmb,
        LogoMGpay,
        LogoUniverso,
        LogoSomma,
    },
    props: {
        logo: {
            required: true,
            type: Object,
            default: () => {}
        }
    }
}
</script>